import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
export type InstructionItemsProps = {
  items: {
    title: string;
    description?: string;
    Icon: Icon;
  }[];
};
const InstructionItems = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="bg-primary rounded grid w-full gap-6 py-2" aria-label="instructionItems">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default InstructionItems;
function _temp(t0) {
  const {
    title,
    description,
    Icon
  } = t0;
  return <li title={title} key={title} className="flex flex-row gap-2"><div className="relative -top-0.5"><Icon color="primary" /></div><div className="flex flex-col gap-2"><p className="text-label-2 text-primary fp-text">{title}</p>{description && <p className="text-body-2 text-secondary fp-text">{description}</p>}</div></li>;
}